import { module } from 'angular';
import { DeleteAccountComponent } from './delete-account.component';
import { DeleteAccountModalModule } from '../../../components/modals/delete-account-modal/delete-account-modal.module';

export const DeleteAccountModule = module('app.shared.delete-account', [
  DeleteAccountModalModule
])
  .component('deleteAccount', DeleteAccountComponent);



// WEBPACK FOOTER //
// ./app/shared/components/delete-account/delete-account.module.ts